/**
 * @Author: chengzh
 * @Date:   2021-08-23 15:10:58
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-08-23 15:12:14
 */
// import appLocaleData from 'react-intl/locale-data/zh';
import zhMessages from './lang/zh-TW.json';
import antdZh from 'antd/lib/locale-provider/zh_TW'; //antd语言包
// console.log(1111,appLocaleData)
let appLocale = {
  messages: {
    ...zhMessages,
  },
  antd: antdZh,
  locale: 'zh-TW',
};

export default appLocale;
